import { WarningCircleIcon } from "@phosphor-icons/react/dist/csr/WarningCircle";
import {
  Empty,
  EmptyContent,
  EmptyDescription,
  EmptyHeader,
  EmptyMedia,
  EmptyTitle,
} from "@volca/ui/components/ui/empty";
import { emptyStateVariants } from "@volca/ui/lib/empty-state";
import { useWorkbookAccessEditorAccess } from "@/payroll/workbook-access/permissions";
import { WorkbookAccessLink } from "@/payroll/workbook-access/workbook-access-link";

export const PayPlanAccessState = ({ businessId }: { businessId: string }) => {
  const { canManage } = useWorkbookAccessEditorAccess(businessId);

  return (
    <Empty className={emptyStateVariants({ layout: "panel" })} role="alert">
      <EmptyHeader>
        <EmptyMedia variant="icon">
          <WarningCircleIcon />
        </EmptyMedia>
        <EmptyTitle>Pay plan access unavailable</EmptyTitle>
        <EmptyDescription>
          You aren't authorized to view the pay plan for this payroll run.
        </EmptyDescription>
      </EmptyHeader>
      {canManage && (
        <EmptyContent>
          <WorkbookAccessLink>Open workbook access</WorkbookAccessLink>
        </EmptyContent>
      )}
    </Empty>
  );
};
